export const CREATE_BANK_TRANSACTION = "CREATE_BANK_TRANSACTION";
export const FETCH_BANK_TRANSACTIONS = "FETCH_BANK_TRANSACTIONS";
export const FETCH_BANK_TRANSACTION = "FETCH_BANK_TRANSACTION";
export const EDIT_BANK_TRANSACTION = "EDIT_BANK_TRANSACTION";
export const DELETE_BANK_TRANSACTION = "DELETE_BANK_TRANSACTION";
